export const ONE_MINUTE_IN_MILLISECONDS = 60000;
